export const environment = {
    production: true,
    hmr       : false,
    // serverURL: 'http://197.254.64.234:8701',
    // AUTH_SERVER_DOMAIN: 'http://197.254.64.234:8701',
    // serverURL: 'https://ndmaapplication.waondosecondary.xyz',
    // AUTH_SERVER_DOMAIN: 'https://ndmaapplication.waondosecondary.xyz',
    serverURL: 'https://lzcore.dews.ndma.go.ke',
    AUTH_SERVER_DOMAIN: 'https://lzcore.dews.ndma.go.ke',
    CLIENT_ID: '',
    TIMEOUT: {
        idle: 2400,
        warning: 60,
    },
    AVAILABLE_HOMEPAGES: [
        'profile',
    ],
};
